import helpers from './helpers.js';

/*
=================================================================
HEIGHT FIX
equalise heights for defined objects
=================================================================
*/
export default (function () {
  return {
    init() {
      if (typeof helpers.maxSliceHeight !== 'function') {
        return;
      }
      window.addEventListener('load', this.run);
      window.addEventListener('resize', this.run);
    },
    run() {
      // generic equalising function based on markup
      const eqCols = document.querySelectorAll('[data-eq-cols]');

      helpers.forEach(eqCols, (i, el) => {
        const json = el.getAttribute('data-eq-cols');
        const selector = el.getAttribute('data-eq-selector') || '>div';
        const sel = el.querySelectorAll(selector);
        const bp = helpers.breakpoint(el);

        let cols;
        if (json === 'length' || json === '*') {
          cols = sel.length;
        } else {
          cols = JSON.parse(json)[bp];
          if (cols === 'length' || cols === '*') {
            cols = sel.length;
          }
        }

        if (cols <= 1) {
          helpers.forEach(sel, (index, element) => {
            element.style.height = '';
          });
          return;
        }
        helpers.maxSliceHeight(sel, cols);
      });
    },
  };
}());
